'use client';

import React from 'react';
import { useColors } from '../theme/ThemeProvider';
import { motion, space } from '../theme/tokens';

export interface ProgressDotsProps {
  /** Number of completed steps (1-indexed). */
  current: number;
  /** Total number of steps. */
  total: number;
}

/**
 * Step indicator — a row of dots where completed steps are elongated.
 * Used in onboarding.
 */
export function ProgressDots({ current, total }: ProgressDotsProps) {
  const colors = useColors();

  return (
    <div
      style={{
        display: 'flex',
        gap: space[2] - 2,
        justifyContent: 'center',
        marginBottom: space[6],
      }}
    >
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          style={{
            width: i < current ? 28 : 8,
            height: 6,
            borderRadius: 3,
            background: i < current ? colors.accent : colors.surfaceAlt,
            transition: `width ${motion.duration.base}ms ${motion.easing.out}, background ${motion.duration.base}ms`,
          }}
        />
      ))}
    </div>
  );
}
